<template>
  <div class="plv-iar-product__popup-link">
    <pc-modal
      :width="720"
      :height="540"
      :show-close="true"
      @close="close()"
    >
      <iframe :src="href" frameborder="0" style="width: 100%; height: 100%;"></iframe>
    </pc-modal>
  </div>
</template>

<script>
import mixin from './mixin';
import PcModal from '@/components/common/modal/PcModal.vue';

export default {
  mixins: [mixin],
  components: { PcModal }
};
</script>
